module.exports = __webpack_public_path__ + "img/tu-4.e52e4934.png";